import { useRouter } from 'next/router'
import type { PylotFrontendConfig } from '../config.d'

const defaultLocale = process.env.NEXT_PUBLIC_DEFAULT_LOCALE || 'en'

export const getStoreCode = (locale?: string): string => {
    const baseStoreCode = process.env.NEXT_PUBLIC_STORE_CODE
    const defaultLocaleOverride =
        process.env.NEXT_PUBLIC_DEFAULT_LOCALE_OVERRIDE || null
    if (defaultLocaleOverride) {
        if (
            baseStoreCode &&
            locale &&
            locale !== 'default' &&
            locale !== defaultLocaleOverride
        ) {
            return `${baseStoreCode}_${locale}`
        } else if (baseStoreCode) {
            return `${baseStoreCode}_${defaultLocaleOverride}`
        }
    } else {
        if (baseStoreCode && locale && locale !== defaultLocale) {
            return `${baseStoreCode}_${locale}`
        } else if (baseStoreCode) {
            return baseStoreCode
        }
    }
    return ''
}

// Load store-specific (if available) or default config
export const getStoreConfig = (locale?: string): PylotFrontendConfig => {
    // Important: do not insert this function call into the next require call (will cause errors)
    const storeCode = getStoreCode(locale)
    /* eslint-disable @typescript-eslint/no-var-requires */
    const { config } = require(`@config/stores/${storeCode}`) as {
        config: PylotFrontendConfig
    }
    return config
}

export const useStoreConfig = (): PylotFrontendConfig => {
    const { locale } = useRouter()
    return getStoreConfig(locale)
}
